import { render } from "./recordList.vue?vue&type=template&id=67ab63c1&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=67ab63c1&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ab63c1"],['__file',"src/views/splitAccount/recordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67ab63c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67ab63c1', __exports__)) {
    console.log('reload')
    api.reload('67ab63c1', __exports__)
  }
  
  module.hot.accept("./recordList.vue?vue&type=template&id=67ab63c1&scoped=true", () => {
    console.log('re-render')
    api.rerender('67ab63c1', render)
  })

}


export default __exports__